(function (angular) {
    'use strict';
     angular.module('SMART2').service('cacheHelperService', [cacheHelperServiceFunc]);

    function cacheHelperServiceFunc() {

        var colDef;
        var filterDef;
        var groupDef;

        function setColDef(_dataModel) {
            colDef = _dataModel;
        }

        function getColDef() {
            if (typeof colDef != undefined) {
                return colDef;
            }
        }

        function setFilterDef(_dataModel) {
            filterDef = _dataModel;
        }

        function getFilterDef() {
            if (typeof filterDef != undefined) {
                return filterDef;
            }
        }

        function setGroupDef(_dataModel) {
            groupDef = _dataModel;
        }

        function getGroupDef() {
            if (typeof groupDef != undefined) {
                return groupDef;
            }
        }

        // It takes savedViews as 1st param and the 2nd parameter represents whether we want the systemDefaultView view flag as true or false.
        function getDefaultSavedView(savedViews, sysDefaultFlag) {
            var defaultView;
            if (sysDefaultFlag) {
                defaultView = _.find(savedViews, function(x) {
                    return x.IsSystemDefault == true;
                });
            } else {
                defaultView = _.find(savedViews, function(x) {
                    return (x.IsSystemDefault == false && ((x.isDefault == true) || (x.IsDefaultView == true)))
                });
            }
            return defaultView;
        }

        var service = {
            setColDef: setColDef,
            getColDef: getColDef,
            setFilterDef: setFilterDef,
            getFilterDef: getFilterDef,
            setGroupDef: setGroupDef,
            getGroupDef: getGroupDef,
            getDefaultSavedView: getDefaultSavedView
        };

        return service;
    };
})(angular);